import './Spacer.css';
import { Box } from '@chakra-ui/react';
export default function Spacer({ height = '50px' }) {
  return <Box height={height}></Box>;
}
